import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_presets} from "../_signals/s_char";
import {ICharPresets} from "../_interfaces/ICharPresets";

export const PresetsGet = (cid: string) => {
    fetch(apiAddress + "/char/presets/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BEPresets get reponse', data.result);
                    s_char_presets.value = (data.result as ICharPresets[])
                }
            }
        )
        .catch((reason => {
            console.log('BEPresets get catch', reason);
        }))
}

export const PresetsCreate = (presets: ICharPresets) => {
    fetch(apiAddress + "/char/presets/", createOptions('CREATE', presets))
        .then((res) => res.json())
        .then((data) => console.log('BEPresets create reponse', data))
        .catch((reason => console.log('BEPresets create catch', reason)))
}

export const PresetsUpdate = (presets: ICharPresets) => {
    fetch(apiAddress + "/char/presets/", createOptions('UPDATE', presets))
        .then((res) => res.json())
        .then((data) => console.log('BEPresets update repsonse', data))
        .catch((reason => console.log('BEPresets update catch', reason)))
}

export const PresetsDelete = (presets: ICharPresets) => {
    fetch(apiAddress + "/char/presets/", createOptions('DELETE', presets))
        .then((res) => res.json())
        .then((data) => console.log('BEPresets delete repsonse', data))
        .catch((reason => console.log('BEPresets delete catch', reason)))
}